import _ from 'lodash'

class Formatter {
  static formatPageInfo(pageInfo) {
    pageInfo.containers = _.map(pageInfo.containers, container => {
      switch (container.type) {
        case 1:
          container = _.assign({}, { editable: true }, container)
          container.tableButtons = Formatter.formatTableButtons(
            container.tableButtons
          )
          container.cols = Formatter.formatTableColumns(container.cols)
          container.rows = Formatter.formatTableRows(
            container.rows,
            _.map(container.cols, col => col.colId)
          )
          break
        case 2:
          container.items = Formatter.formatFormItems(container.items)
          break
      }

      return container
    })

    return pageInfo
  }

  static formatTableButtons(tableButtons) {
    return _.assign(
      {},
      {
        addLine: true,
        copyLines: true,
        deleteLines: true
      },
      tableButtons
    )
  }

  static formatTableColumns(tableColumns) {
    return _.map(tableColumns, tableColumn => {
      const defaultObject = {
        label: '',
        width: '100',
        headerAlign: 'left',
        align: 'left',
        editable: true
      }

      tableColumn = _.assign({}, defaultObject, tableColumn)

      const component = tableColumn.component
      switch (component.type) {
        case 'jtInput':
          component.property = Formatter._formatInputItem(component.property)
          break
        case 'jtEmail':
          component.property = Formatter._formatEmailItem(component.property)
          break
        case 'jtPhone':
          component.property = Formatter._formatPhoneItem(component.property)
          break
        case 'jtDate':
          component.property = Formatter._formatDateItem(component.property)
          break
        case 'jtTime':
          component.property = Formatter._formatTimeItem(component.property)
          break
        case 'jtDateTime':
          component.property = Formatter._formatDateTimeItem(component.property)
          break
        case 'jtIdCard':
          component.property = Formatter._formatIdCardItem(component.property)
          break
        case 'jtIdCardGlobal':
          component.property = Formatter._formatIdCardGlobalItem(component.property)
          break
        case 'jtSingleProject':
          component.property = Formatter._formatSingleProjectItem(
            component.property
          )
          break
        case 'jtGroupProject':
          component.property = Formatter._formatGroupProjectItem(
            component.property
          )
          break
        case 'jtSelect':
          component.property = Formatter._formatSelectItem(component.property)
          break
        case 'jtImage':
          component.property = Formatter._formatImageItem(component.property)
          break
        case 'jtMusic':
          component.property = Formatter._formatMusicItem(component.property)
          break
        case 'jtVideo':
          component.property = Formatter._formatVideoItem(component.property)
          break
        case 'jtBigVideo':
          component.property = Formatter._formatBigVideoItem(component.property)
          break
        case 'jtHtml':
          component.property = Formatter._formatHtmlItem(component.property)
          break
        case 'jtDistrict':
          component.property = Formatter._formatDistrictItem(component.property)
          break
        case 'jtGroupSelect':
          component.property = Formatter._formatGroupSelect(component.property)
          break
        case 'jtStatusButton':
          component.property = Formatter._formatStatusButton(component.property)
          break
        case 'jtRedirectPage':
          component.property = Formatter._formatRedirectPage(component.property)
          break
        case 'jtHtmlEdit':
          component.property = Formatter._formatHtmlEdit(component.property)
          break
        case 'jtLimitSingle':
          component.property = Formatter._formatLimitSingle(component.property)
          break
        case 'jtLimitText':
          component.property = Formatter._formatLimitText(component.property)
          break
        case 'jtActions':
          component.property = Formatter._formatActions(component.property)
          break
        case 'jtLimitGroup':
          component.property = Formatter._formatLimitGroup(component.property)
          break
        case 'jtTaoluRequired':
          component.property = Formatter._formatTaoluRequired(component.property)
          break
        case 'jtTaoluDifficulty':
          component.property = Formatter._formatTaoluDifficulty(component.property)
          break
        case 'jtSingleSelect':
          component.property = Formatter._formatSingleSelect(component.property)
          break
        case 'jtFile':
          component.property = Formatter._formatFile(component.property)
          break
      }
      return tableColumn
    })
  }

  static formatTableRows(tableRows, columnNameArray) {
    return _.map(tableRows, tableRow => {
      const defaultObject = {
        editable: true,
        deletable: true
      }

      tableRow = _.assign({}, defaultObject, tableRow)

      _.forEach(columnNameArray, columnName => {
        tableRow[columnName] = _.assign(
          {},
          { editable: true },
          tableRow[columnName]
        )
      })

      return tableRow
    })
  }

  static formatTableRow(tableRow, columnNameArray) {
    const defaultObject = {
      editable: true
    }

    tableRow = _.assign({}, defaultObject, tableRow)

    _.forEach(columnNameArray, columnName => {
      tableRow[columnName] = _.assign(
        {},
        { editable: true },
        tableRow[columnName]
      )
    })

    return tableRow
  }

  static formatFormItems(items) {
    return _.map(items, item => Formatter.formatItem(item))
  }

  static formatItem(item) {
    const type = item.type
    switch (type) {
      case 'jtInput':
        return Formatter._formatInputItem(item)
      case 'jtEmail':
        return Formatter._formatEmailItem(item)
      case 'jtPhone':
        return Formatter._formatPhoneItem(item)
      case 'jtDate':
        return Formatter._formatDateItem(item)
      case 'jtTime':
        return Formatter._formatTimeItem(item)
      case 'jtDateTime':
        return Formatter._formatDateTimeItem(item)
      case 'jtIdCard':
        return Formatter._formatIdCardItem(item)
      case 'jtIdCardGlobal':
        return Formatter._formatIdCardGlobalItem(item)
      case 'jtSingleProject':
        return Formatter._formatSingleProjectItem(item)
      case 'jtGroupProject':
        return Formatter._formatGroupProjectItem(item)
      case 'jtSelect':
        return Formatter._formatSelectItem(item)
      case 'jtImage':
        return Formatter._formatImageItem(item)
      case 'jtMusic':
        return Formatter._formatMusicItem(item)
      case 'jtVideo':
        return Formatter._formatVideoItem(item)
      case 'jtBigVideo':
        return Formatter._formatBigVideoItem(item)
      case 'jtHtml':
        return Formatter._formatHtmlItem(item)
      case 'jtDistrict':
        return Formatter._formatDistrictItem(item)
      case 'jtGroupSelect':
        return Formatter._formatGroupSelect(item)
      case 'jtRedirectPage':
        return Formatter._formatRedirectPage(item)
      case 'jtStatusButton':
        return Formatter._formatStatusButton(item)
      case 'jtHtmlEdit':
        return Formatter._formatHtmlEdit(item)
      case 'jtLimitSingle':
        return Formatter._formatLimitSingle(item)
      case 'jtLimitText':
        return Formatter._formatLimitText(item)
      case 'jtLimitGroup':
        return Formatter._formatLimitGroup(item)
      case 'jtTaoluRequired':
        return Formatter._formatTaoluRequired(item)
      case 'jtTaoluDifficulty':
        return Formatter._formatTaoluDifficulty(item)
      case 'jtSingleSelect':
        return Formatter._formatSingleSelect(item)
      case 'jtFile':
        return Formatter._formatFile(item)
        break;
    }
  }

  static _formatInputItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: '',
        minLength: 0,
        maxLength: 100
      },
      item
    )
  }

  static _formatHtmlItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: '',
        minLength: 0,
        maxLength: 100
      },
      item
    )
  }
  static _formatDistrictItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: '',
        minLength: 0,
        maxLength: 100
      },
      item
    )
  }

  static _formatGroupSelect(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        options: []
      },
      item
    )
  }
  static _formatEmailItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: ''
      },
      item
    )
  }

  static _formatPhoneItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: ''
      },
      item
    )
  }

  static _formatDateItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: '',
        format: 'YYYY-MM-DD'
      },
      item
    )
  }

  static _formatTimeItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: '',
        format: 'HH:mm'
      },
      item
    )
  }

  static _formatDateTimeItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: '',
        format: 'YYYY-MM-DD HH:mm'
      },
      item
    )
  }

  static _formatIdCardItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: ''
      },
      item
    )
  }
  static _formatIdCardGlobalItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: ''
      },
      item
    )
  }
  static _formatSingleProjectItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: '',
        minLength: 0,
        maxLength: 100,
        suggestions: []
      },
      item
    )
  }

  static _formatGroupProjectItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        placeholder: '',
        tooltip: '',
        minLength: 0,
        maxLength: 100,
        suggestions: []
      },
      item
    )
  }

  static _formatSelectItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        options: []
      },
      item
    )
  }

  static _formatImageItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        src: '',
        thumbnailWidth: '100px',
        thumbnailHeight: '100px',
        supportTypes: ['image/jpeg', 'image/png'],
        supportSize: [5],
        supportMinWidth: 0,
        supportMaxWidth: 1920,
        supportMinHeight: 0,
        supportMaxHeight: 1080
      },
      item
    )
  }

  static _formatMusicItem(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        src: '',
        musicName: '',
        width: '150px',
        height: '30px',
        supportSize: [5],
        supportTypes: ['audio/mp3', 'audio/mpeg']
      },
      item
    )
  }
  static _formatVideoItem(item) {
    item.width = 'auto'
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        src: '',
        videoName: '',
        width: 'auto',
        height: '30px',
        supportSize: [5],
        supportTypes: ['video/mp4', 'video/quicktime']
      },
      item
    )
  }
  static _formatBigVideoItem(item) {
    item.width = 'auto'
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        src: '',
        videoName: '',
        width: 'auto',
        height: '30px',
        supportSize: [5],
        supportTypes: ['video/mp4', 'video/quicktime']
      },
      item
    )
  }
  static _formatStatusButton(item) {
    return _.assign(
      {},
      {
        labelWidth: '30%',
        compWidth: '100%',
      },
      item
    )
  }
  static _formatRedirectPage(item) {
    return _.assign(
      {},
      {
        labelWidth: '30%',
        compWidth: '100%',
      },
      item
    )
  }

  static _formatHtmlEdit(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        tooltip: ''
      },
      item
    )
  }

  static _formatLimitSingle(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        tooltip: ''
      },
      item
    )
  }

  static _formatLimitText(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        tooltip: ''
      },
      item
    )
  }
  static _formatLimitGroup(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        tooltip: ''
      },
      item
    )
  }

  static _formatActions(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        tooltip: ''
      },
      item
    )
  }


  static _formatTaoluRequired(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        tooltip: ''
      },
      item
    )
  }

  static _formatTaoluDifficulty(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        tooltip: ''
      },
      item
    )
  }

  static _formatSingleSelect(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        value: '',
        compWidth: '100%',
        tooltip: ''
      },
      item
    )
  }

  static _formatFile(item) {
    return _.assign(
      {},
      {
        label: '',
        labelWidth: '30%',
        src: '',
        fileName: '',
        width: 'auto',
        height: '30px',
        supportSize: [5],
        supportTypes: []
      },
      item
    )
  }
}

export default Formatter
